// extracted by mini-css-extract-plugin
export var errorIcon = "_mn-1";
export var nameLogo = "_mn-0";